import React from 'react'
import { Text } from '@chakra-ui/react'

function IntroText(props) {
  return (
    <Text
      fontSize={['2xl', '2xl', '3xl']}
      fontFamily="heading"
      lineHeight={1.25}
      width={['full', 'full', 3 / 4]}
      sx={{
        '::after': {
          backgroundColor: `secondary`,
          content: '" "',
          display: 'block',
          width: '16',
          height: '1',
          marginTop: '9',
          marginBottom: '9',
        },
      }}
    >
      {props.children}
    </Text>
  )
}

export default IntroText
